var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400", persistent: "" },
      model: {
        value: _vm.dialogOpen,
        callback: function($$v) {
          _vm.dialogOpen = $$v
        },
        expression: "dialogOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "text-h6" }, [
            _vm._v(" " + _vm._s(_vm.$t("providers.loginRequired")) + " ")
          ]),
          _c("v-card-text", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("providers.loginDialogMessage", {
                    provider: _vm.value
                  })
                ) +
                " "
            )
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.onCancel } },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.onLoginDialogConfirm }
                },
                [_vm._v(" " + _vm._s(_vm.$t("providers.connect")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }